<script setup>
import FeatureCard from '@/components/blocks/FeatureCard.vue'
</script>

<template>
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-6);">
      <h1>Financiële coaching</h1>
      <p>
        Als we aan geld denken, denken we vaak in termen van "tekort". Terwijl we eigenlijk leven in overvloed. Maar juist dat denken in "tekort", zorgt juist voor het "te-kort". Als je gaat denken in overvloed en uitdaging komt er ruimte voor oplossingen. Tot zover de theorie.<br><br>
        In de praktijk wil ik tezamen met jouw, jouw persoonlijke situatie verbeteren. Dat doen we door jouw uitdagingen te vinden en oplossingen te maken. Voor je persoonlijke administratie en je bedrijfsadministratie. Ik coach je in door de wondere wereld van geld en laat je zien waar je recht op hebt, waar je extra geld kan generen en hoe je eventuele uitdagingen kan oplossen.<br><br>
        Neem contact met me op en maak een afspraak, zodat jij ook kan zeggen. Geld is niet alleen rood of groen, maar alle kleuren van de regenboog, mits je bereid bent verder te kijken.<br><br>
      </p>

      <div>
        <h2>Niet alles hoeft moeilijk te zijn</h2>
        <p>
          We maken geld soms ingewikkelder dan het is.<br>
          Rood.<br>
          Groen.<br>
          Plus.<br>
          Min.<br>
          Maar misschien zijn er wel veel meer kleuren.<br>
          Misschien zit er ruimte waar je die nog niet zag.<br>
          Misschien is er een oplossing die je nog niet hebt bedacht.<br>
          Misschien heb je gewoon iemand nodig die even met je meekijkt.<br>
          Dat is wat ik graag doe.
        </p>
      </div>

      <div class="grid-3">
        <FeatureCard title="" text="" icon="steps" />
        <FeatureCard title="" text="" icon="report" />
        <FeatureCard title="" text="" icon="lock" />
      </div>

      <div>
        <h2>Recensies</h2>
        <img src="/images/finance-2.jpg" alt="Voorbeeld rapportage" class="card" />
      </div>

      <div class="actions">
        <router-link class="btn btn-primary" to="/contact">Vrijblijvend kennismaken</router-link>
        <router-link class="btn btn-ghost" to="/">Terug naar home</router-link>
      </div>
    </div>
  </section>
</template>
